import { HTTP } from '@/http/http-client';

const setCustomForms = ({forms, parentId}) => {
    return HTTP.post(`parents/${parentId}/slug/form-answers`, forms);
}

const checkCustomForms = (payload) => {
    const { parentId, childId, ...options } = payload;
    return HTTP.post(`parents/${parentId}/slug/forms-check/${childId}`, options);
}

export default {
    setCustomForms,
    checkCustomForms
};


// WEBPACK FOOTER //
// ./src/http/services/customFormService.js